import React from 'react';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
        <span>About Us<br /></span>
        <h2>About</h2>
        <p>SWOTONN LABS  is a leading pharmaceutical wholesaler dedicated to delivering high-quality healthcare solutions across India. Guided by a mission to enhance healthcare accessibility, we prioritize quality, integrity, and customer satisfaction. Backed by a dynamic leadership team, we are committed to ensuring the availability of essential medicines through efficient distribution channels. Headquartered in Ahmedabad, we strive to be a trusted name in pharmaceutical distribution.</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6 position-relative align-self-start" data-aos="fade-up" data-aos-delay="100">
            <img src="/assets/img/about.png" className="img-fluid" alt="" />
            <a href="https://www.youtube.com/watch?v=Y7f98aduVJ8" className="glightbox pulsating-play-btn" aria-label="Watch Video">
              <span className="visually-hidden">Watch Video</span>
            </a>
          </div>
          <div className="col-lg-6 content" data-aos="fade-up" data-aos-delay="200">
            <h3>Our Mission</h3>
            <p className="fst-italic">
             Enhancing healthcare accessibility with diverse, high-quality pharmaceutical products for communities across India.
            </p>

            <h3>Our Vision</h3>
            <p className="fst-italic">
              SWe aim to lead the pharmaceutical distribution industry with excellence, innovation, and a strong commitment to customer satisfaction.
            </p>

            <h3>Our Values</h3>
            <p className="fst-italic">
            <b>Quality Assurance</b>: We are committed to providing high-quality pharmaceutical products that meet stringentquality standards.<br/></p>
            <p className="fst-italic">
<b>Integrity</b>: We operate with honesty, transparency, and ethical practices in all our business dealings.<br/></p>
            <p className="fst-italic">
<b>Customer Focus</b>: We prioritize customer satisfaction and strive to meet their needs with reliable service and timely delivery.
            </p>
            {/* <ul>
              <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></li>
              <li><i className="bi bi-check2-all"></i> <span>Duis aute irure dolor in reprehenderit in voluptate velit.</span></li>
              <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</span></li>
            </ul> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
